import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../../components/label/sub-text-label/subTextLabel";
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { addSubscriptionRequest, addSubscriptionRequestStatus } from '../../../../redux/subscription/subscription.action'
import CommonInputFloatFull from "../../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonInputRow from "../../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../../components/input/common-input-float-half/commonInputFloafHalf";
import { displayErrorToast, displaySuccessToast, isEmpty } from "../../../../utils/Utils";
import FormFieldLabel from "../../../../components/label/form-field-label/formFieldLabel";
import CommonCheckbox from "../../../../components/common-checkbox/commonCheckbox";
import Select from 'react-select'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../../utils/AppConstants";
import ButtonRow from "../../../../components/button/button-row/buttonRow";
import CommonButton from "../../../../components/button/common-button/commonButton";

const AdminAddSubscription = props => {
    const { addSubscriptionSuccess, addSubscriptionError, addSubscriptionReqStatus } = useSelector(state => state.subscription)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [title, setTitle] = useState('')
    const [longTitle, setLongTitle] = useState('')
    const [savingPercent, setSavingPercent] = useState('')
    const [price, setPrice] = useState('')
    const [finalPrice, setFinalPrice] = useState('')
    const [duration, setDuration] = useState('')
    const [durationLabel, setDurationLabel] = useState('')
    const [isMonthlySelected, setIsMonthlySelected] = useState(false)
    const [isYearlySelected, setIsYearlySelected] = useState(false)
    const [isTrailSubscription, setIsTrialSubscription] = useState(false)
    const [buttonLabel, setButtonLabel] = useState('')
    const [feature, setFeature] = useState('')
    const [featureList, setFeatureList] = useState([])
    const defaultCurrency = {
        "currency": "US dollar",
        "code": "USD",
        "symbol": "$",
        "region": "Americas",
        "country": ["American Samoa", "Ecuador", "El Salvador", "Guam", "Haiti", "Marshall Islands", "Micronesia, Federal States of", "Northern Mariana Islands", "Palau", "Panama", "Puerto Rico", "Timor Leste", "Turks and Caicos Islands", "Virgin Islands (British)", "Virgin Islands (U.S.)"]
    }
    const [selectedCurrency, setSelectedCurrency] = useState()
    const [isMostFlexible, setIsMostFlexible] = useState(false)
    const currencyList = [
        defaultCurrency
    ]

    useEffect(() => {
        if (addSubscriptionReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(addSubscriptionSuccess.message)
            clearField()
        } else if (addSubscriptionReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addSubscriptionError.message)
        }
        if (addSubscriptionReqStatus?.length) {
            dispatch(addSubscriptionRequestStatus(''))
        }
    }, [addSubscriptionSuccess, addSubscriptionError, addSubscriptionReqStatus])

    useEffect(() => {
        if (!isEmpty(price) && !isEmpty(duration)) {
            const fPrice = parseFloat(duration) * parseFloat(price)
            setFinalPrice(fPrice)
        }
    }, [price])

    const handleDurationChoiceType = (type) => {
        if (type === APP_CONSTANTS.SUBSCRIPTION_TYPE.MONTHLY) {
            setIsMonthlySelected(true)
            setIsYearlySelected(false)
        } else if (type === APP_CONSTANTS.SUBSCRIPTION_TYPE.YEARLY) {
            setIsYearlySelected(true)
            setIsMonthlySelected(false)
        }
    }

    const clearField = () => {
        setTitle('')
        setLongTitle('')
        setSavingPercent('')
        setPrice('')
        setFinalPrice('')
        setDuration('')
        setDurationLabel('')
        setIsMonthlySelected(false)
        setIsYearlySelected(false)
        setIsTrialSubscription(false)
        setFeature('')
        setFeatureList([])
        setSelectedCurrency(undefined)
        setIsMostFlexible(false)
        setButtonLabel('')
    }

    const handleSubmitClick = () => {
        if (isEmpty(title)) {
            displayErrorToast('Title cannot be blank')
        } else if (isEmpty(longTitle)) {
            displayErrorToast('Long title cannot be blank')
        } else if (isEmpty(duration)) {
            displayErrorToast('Duration cannot be blank')
        } else if (parseFloat(duration) < 0) {
            displayErrorToast('Invalid duration')
        } else if (isEmpty(durationLabel)) {
            displayErrorToast('Duration label cannot be blank')
        } else if (isMonthlySelected === false && isYearlySelected === false) {
            displayErrorToast('Duration type cannot be blank')
        } else if (isEmpty(price)) {
            displayErrorToast('Price cannot be blank')
        } else if (isEmpty(finalPrice)) {
            displayErrorToast('Final price cannot be blank')
        } else if (isEmpty(selectedCurrency)) {
            displayErrorToast('Currency not selected')
        } else if (isEmpty(featureList)) {
            displayErrorToast('Feature list cannot be blank')
        } else if (isEmpty(buttonLabel)) {
            displayErrorToast('Button label cannot be blank')
        } else {
            setLoading(true)
            const data = {
                userId: '',
                title: title,
                longTitle: longTitle,
                isActive: true,
                isMostFlexible: isMostFlexible,
                price: parseFloat(price),
                discount: 0,
                tax: 0,
                finalPrice: parseFloat(finalPrice),
                currency: selectedCurrency.currency,
                currencyCode: selectedCurrency.code,
                currencySymbol: selectedCurrency.symbol,
                duration: duration,
                durationLabel: durationLabel,
                durationType: isMonthlySelected === true ? APP_CONSTANTS.SUBSCRIPTION_TYPE.MONTHLY : isYearlySelected === true ? APP_CONSTANTS.SUBSCRIPTION_TYPE.YEARLY : '',
                isTrailSubscription: isTrailSubscription,
                productCode: APP_CONSTANTS.PRODUCT_NAME,
                features: featureList,
                buttonLabel: buttonLabel
            }
            if (!isEmpty(savingPercent)) {
                data.savingPercentage = savingPercent
            }
            if (isTrailSubscription) {
                data.type = 'free'
            }
            dispatch(addSubscriptionRequest(data))
        }
    }

    const handleFeatureAddClick = () => {
        if (isEmpty(feature)) {
            displayErrorToast('Feature cannot be blank')
        } else {
            setFeatureList(prevFeatureList => [...prevFeatureList, feature]);
            setFeature('')
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Subscription' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new subscription' />
                    <CommonInputFloatFull
                        type='text'
                        id='title'
                        onChange={e => setTitle(e.target.value)}
                        placeholder='Title'
                        value={title}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='longTitle'
                        onChange={e => setLongTitle(e.target.value)}
                        placeholder='Long Title'
                        value={longTitle}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='duration'
                            onChange={e => setDuration(e.target.value)}
                            placeholder='Duration'
                            value={duration}
                        />
                        <CommonInputFloatHalf
                            type='text'
                            id='durationLabel'
                            onChange={e => setDurationLabel(e.target.value)}
                            placeholder='Duration Label'
                            value={durationLabel}
                            subText='ex. /month or /year'
                            isSubtext={true}
                        />
                    </CommonInputRow>
                    <FormFieldLabel label='Select duration type' />
                    <div className="ap-option-item-container mb-3">
                        <label className="ap-choice-label-container">
                            <input type='radio' value={APP_CONSTANTS.SUBSCRIPTION_TYPE.MONTHLY} checked={isMonthlySelected} onChange={e => handleDurationChoiceType(e.target.value)} />
                            <span className="ap-choice-label">Monthly</span>
                        </label>
                        <label className="ap-choice-label-container">
                            <input type='radio' value={APP_CONSTANTS.SUBSCRIPTION_TYPE.YEARLY} checked={isYearlySelected} onChange={e => handleDurationChoiceType(e.target.value)} />
                            <span className="ap-choice-label">Yearly</span>
                        </label>
                    </div>
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='price'
                            onChange={e => setPrice(e.target.value)}
                            placeholder='Price'
                            value={price}
                        />
                        <CommonInputFloatHalf
                            type='number'
                            id='finalPrice'
                            onChange={e => setFinalPrice(e.target.value)}
                            placeholder='Final Price'
                            value={finalPrice}
                            isDisable={true}
                        />
                    </CommonInputRow>
                    <FormFieldLabel className='up-bold-label' label='Customizations' />
                    <FormFieldLabel label='Select Currency' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedCurrency}
                        getOptionLabel={e => e.currency}
                        getOptionValue={e => e}
                        options={currencyList}
                        placeholder='Select Currency'
                        onChange={e => setSelectedCurrency(e)} />
                    <CommonInputFloatFull
                        type='text'
                        id='savingPercentage'
                        onChange={e => setSavingPercent(e.target.value)}
                        placeholder='Saving Percentage'
                        value={savingPercent}
                    />
                    <CommonCheckbox
                        id='flexible'
                        label='Is most flexible'
                        value={isMostFlexible}
                        onChange={() => {
                            setIsMostFlexible(!isMostFlexible)
                        }}
                    />
                    <CommonCheckbox
                        id='flexible'
                        label='Is trail subscription'
                        value={isTrailSubscription}
                        onChange={() => {
                            setIsTrialSubscription(!isTrailSubscription)
                        }}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='buttonLabel'
                        onChange={e => setButtonLabel(e.target.value)}
                        placeholder='Button label'
                        value={buttonLabel}
                    />
                    <FormFieldLabel label='Features' />
                    <div className="as-feature-container">
                        <div className="as-feature-input-container">
                            <CommonInputFloatFull
                                type='text'
                                id='feature'
                                onChange={e => setFeature(e.target.value)}
                                placeholder='Feature'
                                value={feature}
                            />
                        </div>
                        <div className="as-add-btn-container" onClick={() => { handleFeatureAddClick() }}>Add</div>
                    </div>
                    {!isEmpty(featureList) && <div className="as-feature-list-container">
                        {featureList.map(item => (<div className="as-feature-row-container">{item}</div>))}
                    </div>}
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AdminAddSubscription